<template>
  <el-card class="h-full">
    <div class="w-full h-full flex flex-col" v-if="currentComp === 'TABLE'">
      <div class="flex mb-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="考试名称/编码"
          maxlength="50"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-select
          v-model="searchData.examCategory"
          size="small"
          class="mr-10px !w-50 mb-10px mb-10px"
          placeholder="请选择考试类型"
          clearable
        >
          <el-option
            v-for="item in pagerTypeList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-date-picker
          class="mr-10px mb-10px"
          v-model="datePickerValue"
          format="yyyy-MM-dd"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>

        <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
        <el-button class="mb-10px" size="small" type="primary" @click="searchList()"
          >搜索</el-button
        >
        <el-button
          class="mb-10px"
          size="small"
          type="primary"
          @click="handleEvent(null, 'create')"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
      </div>
      <div class="flex-auto h-0px">
        <el-table
          :data="tableData"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          v-loading="loading"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="考试名称" prop="examName" show-overflow-tooltip />
          <el-table-column label="考试编码" prop="examCode" show-overflow-tooltip />
          <el-table-column
            label="考试类型"
            width="140"
            prop="examCategoryStr"
            show-overflow-tooltip
          />
          <el-table-column label="考试时间" width="220" prop="examType" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row | dateFilter }}
            </template>
          </el-table-column>
          <el-table-column
            label="考试总时长(分钟)"
            prop="totalPlanExamDuration"
            show-overflow-tooltip
          >
            <!-- <template slot-scope="scope">
              {{ scope.row | duration }}
            </template> -->
          </el-table-column>
          <el-table-column label="考试总场次" prop="totalExamSessionCount" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="考试状态" prop="examPlanStatusStr" show-overflow-tooltip />
          <el-table-column label="发起人" prop="sponsorName" show-overflow-tooltip />
          <el-table-column label="考试公告" prop="examNotice" show-overflow-tooltip />
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <!-- <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'read')"
                :disabled="!$hasAccess('read')"
                >查看</el-button
              >
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'update')"
                :disabled="
                  dynamicControl(scope.row) ||
                    !($hasAccess('update') && scope.row.examPlanStatus === 0)
                "
                >编辑</el-button
              >
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'publish')"
                :disabled="
                  dynamicControl(scope.row) ||
                    !($hasAccess('publish') && scope.row.examPlanStatus === 0)
                "
                >发布</el-button
              >
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'delete')"
                :disabled="!($hasAccess('delete') && getDeletAuth(scope.row))"
                >删除</el-button
              > -->
              <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="searchList"
          @current-change="findList"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="total"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
    <ExamPlanForm
      v-else
      :pageType="operateType"
      @refreshList="refreshList"
      :operateData="operateData"
      @cancel="checkComp('TABLE')"
    ></ExamPlanForm>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import { ExamPlanApi } from '@wiz-api/exam-management'
import utils from '@/components/safety/enumField/utils'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import ExamPlanForm from '../../components/examManage/ExamPlanForm'

const examPlanApi = new ExamPlanApi()

export default {
  name: 'exam-plan',
  components: {
    ExamPlanForm,
    TableOperateButton,
  },
  filters: {
    dateFilter(row) {
      if (row.examStartTime && row.examEndTime) {
        return `
          ${dayjs(row.examStartTime).format('YYYY-MM-DD')} -
          ${dayjs(row.examEndTime).format('YYYY-MM-DD')}
        `
      }
      return ''
    },
    duration(row) {
      const value = [row.examStartTime, row.examEndTime]
      return Math.floor(Math.abs(new Date(value[1]) - new Date(value[0])) / 60000)
    },
  },
  data() {
    return {
      datePickerValue: [],
      nowTime: dayjs(),
      timer: null,
      typeList: [],
      tableData: [],
      loading: false,
      searchData: {},
      currentComp: 'TABLE',
      total: 0,
      pageNo: 1,
      pageSize: 15,
      operateType: '',
      operateData: {},
      pagerTypeList: [],
    }
  },
  watch: {
    datePickerValue(list) {
      if (list && list.length) {
        this.searchData.examStartTime = dayjs(list[0]).format('YYYY-MM-DD HH:mm:ss')
        this.searchData.examEndTime = dayjs(list[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchData.examStartTime = ''
        this.searchData.examEndTime = ''
      }
    },
  },
  computed: {
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow:
              this.$hasAccess('update') && (val.examPlanStatus === 0 || val.examPlanStatus === 3),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete') && this.getDeletAuth(val),
          },
          {
            text: '发布',
            click: () => {
              return this.handleEvent(val, 'publish')
            },
            isShow: this.$hasAccess('publish') && val.examPlanStatus === 0,
          },
          {
            text: '撤回',
            click: () => {
              return this.handleEvent(val, 'withdraw')
            },
            isShow:
              !this.disabledWithdraw(val) &&
              this.$hasAccess('withdraw') &&
              val.examPlanStatus === 1,
          },
          {
            text: '变更',
            click: () => {
              return this.handleEvent(val, 'change')
            },
            isShow:
              !this.disabledChange(val) &&
              this.$hasAccess('change') &&
              val.isAnyTime &&
              val.examPlanStatus === 1,
          },
        ]
      }
    },
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    getDeletAuth() {
      return (row) => {
        if (!row.examSessions) return false
        const list = row.examSessions
        return !list.every((item) => {
          return this.nowTime >= dayjs(item.singleExamStartTime)
        })
      }
    },
    dynamicControl() {
      return (row) => {
        if (this.nowTime > dayjs(row.examSessions[row.examSessions.length - 1].singleExamEndTime)) {
          return true
        }
        return false
      }
    },
    disabledWithdraw() {
      return (row) => {
        if (this.nowTime > dayjs(row.examStartTime)) {
          return true
        }
        return false
      }
    },
    disabledChange() {
      return (row) => {
        if (this.nowTime < dayjs(row.examStartTime) || this.nowTime > dayjs(row.examEndTime)) {
          return true
        }
        return false
      }
    },
  },
  methods: {
    // 刷新接口
    refreshList() {
      this.checkComp('TABLE')
      this.searchList()
    },
    // 字典
    async getRegulationType() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['TrainingType'],
        includeDetails: true,
      })
      if (err) return
      // 字典-事故类型
      this.trainingType = res[0]?.dataItems
    },
    // 操作
    handleEvent(row, type) {
      if (type === 'delete') {
        this.$confirm('是否删除该记录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err, res] = await examPlanApi.callDelete(row.id)
            if (!err) {
              this.$message.success('删除成功')
              this.findList()
            }
          })
          .catch(() => {})
        return
      }
      if (type === 'publish') {
        this.$confirm('请确认是否发布该计划？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.loading = true
            const [err, res] = await examPlanApi.publishExamPlan({
              id: row.id,
            })
            if (!err) {
              this.$message.success('发布成功')
              this.findList()
            } else {
              this.findList()
            }
          })
          .catch(() => {})
        return
      }
      if (type === 'withdraw') {
        this.$confirm('请确认是否撤回该计划？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.loading = true
            const [err] = await examPlanApi.revokeExamPlan({
              id: row.id,
            })
            if (!err) {
              this.$message.success('撤回成功')
              this.findList()
            } else {
              this.findList()
            }
          })
          .catch(() => {})
        return
      }
      this.operateType = type
      this.operateData = row
      this.checkComp('action')
    },
    // 切换组件
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.datePickerValue = []
      this.searchList()
    },
    /**
     * @description 分页数改变
     */
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [err, res] = await examPlanApi.pagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
  },
  created() {
    utils.getDataCategory(['ExamManagement.DataCategory.ExamType'], ['pagerTypeList'], this)
    this.searchList()

    if (this.timer) return
    this.timer = setInterval(() => {
      this.nowTime = dayjs()
    }, 5000)
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  activated() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.timer = setInterval(() => {
      this.nowTime = dayjs()
    }, 5000)
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
